import {PipettingParameterFieldKey, TaskType} from './dataEnum';

export const DefaultDispensePipettingParameterValue = {
  [PipettingParameterFieldKey.PRECISION_DISPENSE]: false,
  [PipettingParameterFieldKey.DISPENSE_AT_WELL_SIDE]: false,
};

export const DefaultPipettingParameterValue = {
  [TaskType.DISPENSE]: DefaultDispensePipettingParameterValue,
};

export const PIPETTING_PARAMETERS_TIP_DIRECTIONAL_SETTINGS = [
  PipettingParameterFieldKey.TIP_TOUCH_OFF_DIRECTION_X,
  PipettingParameterFieldKey.TIP_TOUCH_OFF_DIRECTION_Y,
  PipettingParameterFieldKey.TIP_POSITION_X_OFFSET,
  PipettingParameterFieldKey.TIP_POSITION_Y_OFFSET,
];
